
document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function (e) {
  try {
    let wishlistItems = await window.WishListHero_SDK.GetWishListItemsFromServer();
    let wishlistItemsLength = wishlistItems.length;
    if(wishlistItemsLength > 0){

      const elmMainContent = document.getElementById("MainContent");
      const addHtml =  `
        <div class="awoo-favorite-related-products_wrap index-section">
          <div class="page-width">
            <div class=" only-sp">
              <div class="awoo-favorite-related-products"></div>
            </div>
            <div class=" only-pc">
              <div class="awoo-favorite-related-products" no-swiper></div>
            </div>
          </div>
        </div>`;
      elmMainContent.insertAdjacentHTML("beforeend",addHtml);

      let productIds = [];
      for(i=0; i < wishlistItemsLength; i++){
        productIds.push(wishlistItems[i].ProductId);
      }
      const productIdsCommaSeparated = productIds.join(",")
      window.awooConfig = Object.assign(window.awooConfig || {}, {
        relatedProductIds: productIdsCommaSeparated
      });
    }else{
      // お気に入り商品が0の場合はポピュラーな商品を表示
      const elmMainContent = document.getElementById("MainContent");
      const addHtml =  `
        <div class="awoo-favorite-related-products_wrap index-section">
          <div class="page-width">
            <div class=" only-sp">
              <div class="awoo-keyword-popular-products"></div>
            </div>
            <div class=" only-pc">
              <div class="awoo-keyword-popular-products" no-swiper></div>
            </div>
          </div>
        </div>`;
      elmMainContent.insertAdjacentHTML("beforeend",addHtml);
    }


  } catch (err) {
      console.error(err)
  }
});
